import React from 'react';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  id: 1,
  name: 'Martín R.',
  age: 42,
  city: 'Córdoba',
  role: 'Emprendedor',
  text: 'Quería lograr independencia energética en mi casa pero todos los manuales que encontraba parecían escritos en chino. Este pack me salvó. Fui paso a paso y ya tengo mi primer panel funcionando. ¡Excelente inversión!',
  initials: 'MR',
  color: 'bg-blue-500'
}, {
  id: 2,
  name: 'Laura G.',
  age: 35,
  city: 'Mendoza',
  role: 'Madre de familia',
  text: 'Las boletas de luz venían cada vez más caras. Compré el curso con miedo porque no soy técnica, pero está tan bien explicado que pude dimensionar el equipo que necesitábamos sin que me vendan cualquier cosa. 100% recomendado.',
  initials: 'LG',
  color: 'bg-green-500'
}, {
  id: 3,
  name: 'Carlos D.',
  age: 51,
  city: 'Rosario',
  role: 'Instalador',
  text: 'Hacía changas eléctricas y quería formalizarme instalando paneles. La información técnica de los tomos 2 y 3 es oro puro. Ahora ofrezco el servicio con total seguridad y sé exactamente qué materiales comprar.',
  initials: 'CD',
  color: 'bg-orange-500'
}, {
  id: 4,
  name: 'Valentina S.',
  age: 28,
  city: 'Buenos Aires',
  role: 'Joven emprendedora',
  text: 'Me sorprendió la calidad del material. El Tomo 10 con el caso real es lo mejor, te muestra exactamente cómo se hace en la práctica. Ya estoy armando mi propio proyecto para independizarme de la red.',
  initials: 'VS',
  color: 'bg-purple-500'
}, {
  id: 5,
  name: 'Roberto M.',
  age: 47,
  city: 'Tucumán',
  role: 'Dueño de casa rural',
  text: 'En el campo la luz se corta siempre. Con estas guías pude entender qué baterías necesitaba y cómo conectar todo sin quemar nada. Lo leí en dos días y al tercero ya estaba comprando los materiales correctos.',
  initials: 'RM',
  color: 'bg-red-500'
}];
export function Testimonials() {
  return <div className="py-12 bg-gray-50 border-y border-gray-200" data-id="element-160">
      <div className="max-w-4xl mx-auto px-4" data-id="element-161">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-10" data-id="element-162">
          Lo que dicen quienes ya lo tienen
        </h2>

        <div className="grid gap-6 md:grid-cols-2" data-id="element-163">
          {testimonials.map((t, index) => <div key={t.id} className={`bg-white p-6 rounded-xl shadow-md border border-gray-100 ${index === 4 ? 'md:col-span-2 md:max-w-xl md:mx-auto' : ''}`} data-id="element-164">
              <div className="flex items-center gap-4 mb-4" data-id="element-165">
                <div className={`w-12 h-12 rounded-full ${t.color} flex items-center justify-center text-white font-bold text-lg shadow-inner`} data-id="element-166">
                  {t.initials}
                </div>
                <div data-id="element-167">
                  <h4 className="font-bold text-gray-900" data-id="element-168">
                    {t.name}, {t.age} años
                  </h4>
                  <p className="text-sm text-gray-500" data-id="element-169">
                    {t.city} - {t.role}
                  </p>
                </div>
              </div>

              <div className="flex gap-1 mb-3" data-id="element-170">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-171" />)}
              </div>

              <p className="text-gray-700 italic leading-relaxed" data-id="element-172">"{t.text}"</p>
            </div>)}
        </div>
      </div>
    </div>;
}